import type { StickyFeature } from "../features/StickyFeature";
import type { TopStrategyParams } from "../TopStrategyTuner.types";
// TODO: Remove in COTECH-2882
import { TopMarginApplier } from "../features/helpers/TopMarginApplier";

export class StickyFeatureActivator {
  private activating: boolean = false;
  private feature?: StickyFeature;
  private killDeactivation: boolean = false;
  private onRemoveStickinessCallback: (() => void) | undefined;

  // TODO: Remove constructor in COTECH-2882
  constructor(
    private readonly marginApplier: TopMarginApplier = new TopMarginApplier(),
  ) {}

  activate(options: TopStrategyParams) {
    if (this.activating || this.feature) {
      return;
    }

    this.activating = true;

    import("../features/StickyFeature")
      .then(({ StickyFeature }) => {
        // TODO: Remove `this.marginApplier` in COTECH-2882
        this.feature = new StickyFeature(this.marginApplier);
        this.feature.activate(options);
        this.activating = false;

        if (this.onRemoveStickinessCallback) {
          this.feature.onRemoveStickiness(this.onRemoveStickinessCallback);
        }
      })
      .catch(() => {
        this.activating = false;
        throw new Error("Failed to load StickyFeature");
      });
  }

  addOnRemoveStickiness(callback: () => void) {
    if (!this.feature) {
      this.onRemoveStickinessCallback = callback;
      return;
    }

    this.feature.onRemoveStickiness(callback);
  }

  deactivate() {
    if (this.killDeactivation) {
      this.killDeactivation = false;
      return;
    }

    if (!this.feature) {
      setTimeout(() => {
        this.deactivate();
      }, 100); // Wait for the feature to be activated
      return;
    }
    this.feature.removeStickiness();
  }

  reactivate(options: TopStrategyParams, disableAutoUnstick: boolean) {
    this.killDeactivation = true;

    if (!this.feature) {
      this.activate({
        ...options,
        disableAutoUnstick,
      });
      return;
    }

    this.feature.activate({
      ...options,
      disableAutoUnstick,
    });
  }
}
